// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 1L21 23H3V1H21ZM17 13H7V15H17V13ZM15 17H7V19H15V17ZM11 3H7L7 8.5L9 6.85L11 8.5V3Z"}}]};

const Certificate1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'certificate-1-filled',
    ref,
    icon: element,
  },
));

Certificate1FilledIcon.displayName = 'Certificate1FilledIcon';

export default Certificate1FilledIcon;
